import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import PopulatingModal from "../audiences/PopulatingModal";

/**
 * Progress modal for stale audience open or after manual sync. Reuses PopulatingModal (population-status API).
 */
export default function AudiencePopulatingModal({ landingPath }) {
  const { hash } = useParams();
  const navigate = useNavigate();
  const closePath = landingPath || `/audience/${hash}/`;

  const handleClose = () => {
    navigate(closePath);
  };

  if (!hash) return null;

  return (
    <Modal onClose={handleClose}>
      <PopulatingModal variant="sync" existing />
    </Modal>
  );
}
